import apiActions from "app/utils/apiActions";
import timeHelpers from "app/utils/timeHelpers";
import alertActions from "app/utils/alertActions";

import store from "app/redux/store";
import { index, create, update, add } from "app/actions/moments";
import { setLoading, setUpdatedAt } from "app/actions/app";

let momentActions = {
  async index(weeks = 1) {
    return await apiActions.request(`moments?weeks=${weeks}`, "GET");
  },
  async complete(id, completed_at = new Date()) {
    // let data = { completed_at: timeHelpers.dateTimeToDate(completed_at) };
    let data = { completed_at: completed_at };
    return await apiActions.request(`moments/${id}`, "PATCH", data);
  },
  async uncomplete(id) {
    let data = { completed_at: null };
    return await apiActions.request(`moments/${id}`, "PATCH", data);
  },
  async update(id, data) {
    let res = await apiActions.request(`moments/${id}`, "PATCH", data);
    if (res === null) {
      const existing = store.getState().moments.find((m) => m.id == id);
      if (existing) store.dispatch(update({ ...existing, ...data, id }));
      return { success: true, queued: true };
    }
    // if (res?.sucess && res?.value) store.dispatch(update(res.value));
    if (res?.success && res?.moment) store.dispatch(update(res.moment));
    return res;
  },
  async delete(id, prompt = true) {
    if (prompt) {
      let promptText =
        typeof prompt == "string" ? prompt : "Remove item from chapter?";
      let conf = await alertActions.confirm(promptText);
      if (!conf) return false;
    }
    return await apiActions.request(`moments/${id}`, "DELETE");
  },
  async convertToValue(id) {
    return await apiActions.request(`moments/${id}/convert_to_value`, "POST");
  },
  async copyToNextChapter(id) {
    return await apiActions.request(
      `moments/${id}/copy_to_next_chapter`,
      "POST",
    );
  },
  async create(moment, chapter_id = null) {
    // store.dispatch(setLoading(true));
    let res = await apiActions.request(`moments`, "POST", { moment });
    moment = res?.moment;
    // store.dispatch(setLoading(false));
    if (!moment || !res.success) return;
    // store.dispatch(create(moment));
    return moment;
  },
  async pinToChapter(id, chapter_id) {
    return await apiActions.request(`moments/${id}/pin_to_chapter`, "POST", {
      chapter_id,
    });
  },
};

export default momentActions;
